import { merge } from 'lodash';
import { formatTimestamp } from '@/utils/utils';

export function imsEchart(op) {
  return merge(
    {
      title: {
        text: '传感器阵列',
        left: 'center',
        textStyle: {
          color: '#00A0E9',
          fontSize: 20
        }
      },
      visualMap: {
        max: 1e5,
        dimension: 'imsValue',
        inRange: {
          color: ['#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695']
        },
        textStyle: {
          color: '#00A0E9'
        }
      },
      grid3D: {
        height: '95%',
        axisTick: {
          show: false
        },
        viewControl: {
          alpha: 40
        },
        axisLine: {
          lineStyle: {
            color: '#00A0E9'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#00A0E9'
          }
        },
        axisLabel: { show: false }
      },
      tooltip: {
        formatter(params) {
          return `${formatTimestamp(params.data[0])}: ${params.data[1]}的值为${params.data[2]}`;
        }
      },
      xAxis3D: {
        name: '时间',
        type: 'time',
        nameTextStyle: {
          color: '#00A0E9',
          fontSize: 14
        }
      },
      yAxis3D: {
        name: '传感器通道',
        type: 'category',
        nameTextStyle: {
          color: '#00A0E9',
          fontSize: 14
        }
      },
      zAxis3D: {
        name: '信号强度',
        type: 'value',
        nameTextStyle: {
          color: '#00A0E9',
          fontSize: 14
        }
      },
      dataset: {
        dimensions: ['time', 'ims', 'imsValue'],
        source: []
      },
      series: [
        {
          type: 'bar3D',
          shading: 'lambert',
          encode: {
            x: 'time',
            y: 'ims',
            z: 'imsValue'
          },
          emphasis: {
            label: {
              formatter(params) {
                return params.data[2];
              }
            }
          }
        }
      ]
    },
    op
  );
}
